import { TextareaAutosize, Typography } from '@mui/material';
import moment from 'moment';
import React, { forwardRef, useEffect, useState } from 'react';
import LeftArrow from '../../../../../asset/svg/leftArrow.svg';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ReactDatePicker from 'react-datepicker';
import '../../../../../scss/pages/Attendance/Component/Checklist/EditSchedule/EditSchedule.scss';
import { useLocation, useNavigate } from 'react-router';
import { CHECKLIST_PLANNER_PATH, CHECKLIST_RESCHEDULE_HISTORY } from '../../../../../utils/Constants';
import { useDispatch } from 'react-redux';
import { POST_UPDATE_SCHEDULE } from '../../../../../sagas/type';
import { useSnackbar } from 'notistack';

function EditShcedule() {
    const navigate = useNavigate();
    const location = useLocation();
    const dispatch = useDispatch();
    const { enqueueSnackbar } = useSnackbar();
    const { editData, filterState } = location?.state;
    const [date, setDate] = useState('');
    const [reason, setReason] = useState('');
    const [isValid, setIsValid] = useState(false)

    const handleBack = () => {
        navigate(CHECKLIST_PLANNER_PATH, { state: { editData: editData, filterState: filterState } })
    }

    const handleDateChange = (event) => {
        const selectDate = moment(event).format('DD MMM yyyy')
        setDate(selectDate)
    };

    const handleChange = (e) => {
        setReason(e.target.value);
    }

    const handleEditSchedule = () => {
        const addNewDate = moment(date).format('yyyy-MM-DD')
        const payloadData = {
            startDate: addNewDate,
            endDate: addNewDate,
            checklistId: editData?.checklistId,
            reason: reason,
            createdBy: editData?.createdBy,
        }
        dispatch({
            type: POST_UPDATE_SCHEDULE,
            payload: { payloadData: payloadData, scheduleId: editData?.id },
            navigate: navigate,
            enqueueSnackbar, enqueueSnackbar,
        })
    }

    const handleRescheduleHistory = () => {
        navigate(CHECKLIST_RESCHEDULE_HISTORY, { state: { editData: editData, filterState: filterState } })
    }

    useEffect(() => {
        const isDate = date !== '';
        const isReason = reason !== '';
        setIsValid(isDate && isReason)
    }, [date, reason])

    const ExampleCustomInput = forwardRef(({ value, onClick }, ref) => (
        <button className="EditSchedule-container_Card-Parent_checklist_ScheduleDate_datepicker" onClick={onClick} ref={ref}>
            <Typography sx={{ fontSize: "12px", color: editData?.maxRescheduleLimit === editData?.rescheduledCount ? "#FFF" : "#8074FF", fontWeight: 600 }}>Add New Date </Typography>
        </button>
    ));
    return (
        <div className='EditSchedule-container'>
            <div className='EditSchedule-container_header'>
                <div className='EditSchedule-container_header_head-height'>
                    <img className='EditSchedule-container_header_head-height_image' src={LeftArrow} alt="" onClick={handleBack} />&nbsp;&nbsp;
                    <span className='EditSchedule-container_header_head-height_content'>Edit Schedule</span>
                </div>
                <Typography className='EditSchedule-container_header_head-height_applyFilter-link' onClick={handleRescheduleHistory}>History</Typography>
            </div>
            <div>
                <div className='EditSchedule-container_Card-Parent'>
                    <div className="EditSchedule-container_Card-Parent_checklist">
                        <div>
                            <Typography sx={{ color: 'rgba(255, 255, 255, 1)', opacity: 0.54, fontWeight: 400, fontSize: '12px', lineHeight: '12px', padding: " 0 0 7px 0 " }}>Checklist</Typography>
                            <Typography sx={{ color: "#FFF", fontWeight: 600, fontSize: '14px', lineHeight: '12px', textTransform: 'capitalize', marginTop: "2px", }} value="name">{editData?.checklistName}</Typography>
                        </div>
                        <div className="EditSchedule-container_Card-Parent_checklist_ScheduleDate">
                            <Typography sx={{ color: 'rgba(255, 255, 255, 1)', opacity: 0.54, fontWeight: 400, fontSize: '12px', lineHeight: '12px', padding: " 0 0 5px 0 " }}>Schedule Date</Typography>
                            {date ? <Typography sx={{ fontSize: "12px", color: "#8074FF", fontWeight: 600, paddingLeft: "2px" }}>{date}</Typography>
                                : <ReactDatePicker
                                    onChange={(e) => handleDateChange(e)}
                                    dateFormat="dd-MM-yyyy"
                                    onBlur={() => setSelectedItemId(null)}
                                    minDate={new Date()}
                                    customInput={<ExampleCustomInput />}
                                    disabled={editData?.rescheduledCount === editData?.maxRescheduleLimit}
                                />}
                        </div>
                    </div>
                    <div className="EditSchedule-container_Card-Parent_checklist">
                        <div className="EditSchedule-container_Card-Parent_checklist_mleft">
                            <Typography sx={{ color: 'rgba(255, 255, 255, 1)', opacity: 0.54, fontWeight: 400, fontSize: '12px', lineHeight: '12px', padding: " 0 0 7px 0 " }}>Store</Typography>
                            <Typography sx={{ color: "#FFF", fontWeight: 600, fontSize: '14px', lineHeight: '12px', textTransform: 'capitalize', marginTop: "2px", }} value="name">{editData?.storeCode} - {editData?.storeName}</Typography>
                        </div>
                    </div>
                </div>
            </div>
            {editData?.rescheduledCount === editData?.maxRescheduleLimit && <div className='EditSchedule-container_ReScheduleLImitCard'>
                <Typography sx={{ color: "#FF7272", fontSize: "11px", padding: "0.5rem" }}>Reschedule limit is over. You can only reschedule 2 times</Typography>
            </div>}
            {editData?.rescheduledCount !== editData?.maxRescheduleLimit && <div className='EditSchedule-container_Reason'>
                <Typography sx={{ color: 'rgba(255, 255, 255, 1)', opacity: 0.54, fontWeight: 400, fontSize: '12px', lineHeight: '12px', padding: 0, marginTop: "0.5rem" }}>Reason</Typography>
                <div className='EditSchedule-container_Reason_textArea'>
                    <TextareaAutosize minLength={4} maxRows={4} placeholder="Type here…" style={{ padding: '4%', overflow: "auto", width: "100%", height: "70px", fontSize: "12px", fontWeight: 400, borderRadius: "9px", backgroundColor: "transparent", border: "none", color: "#FFF", fontFamily: "'Noto Sans', sans-serif", resize: "none" }} onChange={handleChange} />
                </div>
            </div>}
            <div className='EditSchedule-container_Download-button'>
                <div className='EditSchedule-container_Download-button_btn-bottom'>
                    <div className='EditSchedule-container_Download-button_btn-bottom_okbutton-container'>
                        <button disabled={!isValid} id='downloadBtn' className='EditSchedule-container_Download-button_btn-bottom_okbutton-container_active-button' onClick={handleEditSchedule}>Update</button>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default EditShcedule